import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';
import React, { useEffect, useState, useCallback } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
  Button,
} from '@mui/material';
import { AxiosResponse } from 'axios';

interface BulkSchedulePrintDialogProps {
  providerUUID: any;
  dateString: string;
  open: boolean;
  onClose: () => void;
  scheduling?: boolean;
  discipline?: string;
}

const BulkSchedulePrintDialog: React.FC<BulkSchedulePrintDialogProps> = ({
  providerUUID,
  dateString,
  open,
  onClose,
  scheduling,
  discipline
}) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPdf = useCallback(() => {
    setLoading(true);
    setError(null);

    therapistSchedulingServices
      .getBulkPrintPDFUrl(providerUUID, dateString, discipline)
      .then((response: AxiosResponse<any>) => {
        const responseData = response.data;
        if (responseData.code === 'OK' && responseData.message && !scheduling) {
          setPdfUrl(responseData.message);
        } else if (responseData.code === 'OK' && responseData.data && scheduling) {
          setPdfUrl(responseData.data);
        } else {
          setError('Failed to fetch PDF URL.');
        }
      })
      .catch(() => setError('An error occurred while fetching the PDF URL.'))
      .finally(() => setLoading(false));
  }, [providerUUID, dateString, discipline, scheduling]);

  useEffect(() => {
    if (open) {
      fetchPdf();
    }
  }, [fetchPdf, open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>Print Everyone&apos;s Schedules</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100%"
            textAlign="center"
          >
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            <Typography style={{ color: 'red', marginBottom: '16px' }}>{error}</Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={fetchPdf}
            >
              Retry
            </Button>
          </Box>
        ) : pdfUrl ? (
          <iframe
            src={pdfUrl}
            title="Bulk Schedule PDF"
            style={{ width: '100%', height: '80vh', border: 'none' }}
          />
        ) : (
          <div>No PDF URL available.</div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default BulkSchedulePrintDialog;
